var _style, _defs, _defs2, _rect, _defs3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxausgewaehlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.32 41.15",
    style: {
      enableBackground: "new 0 0 42.32 41.15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000183930775434436721520000013621763660250117545_);fill:none;stroke:#000000;stroke-width:1.5;}\n\t.st1{clip-path:url(#SVGID_00000047767133961766523400000003697853756364996518_);fill:none;stroke:#000000;stroke-width:1.5;}\n\t.st2{fill:none;stroke:#000000;stroke-width:1.3;}\n\t.st3{clip-path:url(#SVGID_00000178207224871419011750000007544941791925639845_);fill:none;stroke:#000000;stroke-width:1.5;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 42.1,
    y: -1.21,
    transform: "matrix(0.0536 -0.9986 0.9986 0.0536 41.2754 62.2923)",
    width: 22.81,
    height: 21.16
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000076591788938009429930000012613134885692214187_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000076591788938009429930000012613134885692214187_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.5
    },
    d: " M63.96-0.86"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000076591788938009429930000012613134885692214187_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.5
    },
    d: " M43.04,19.6"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000031181398699402627500000010950762537940801947_",
    x: 0.54,
    y: -1.41,
    transform: "matrix(0.9986 -0.0536 0.0536 0.9986 -1.065 1.1476)",
    width: 40.64,
    height: 43.68
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104671712369838543030000013565886396463999666_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031181398699402627500000010950762537940801947_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000104671712369838543030000013565886396463999666_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.5
    },
    x1: 40.95,
    y1: 40.01,
    x2: 0.77,
    y2: 0.84
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.61,
    y: 0.66,
    className: "st2",
    width: 41.06,
    height: 39.91
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000147214374176044115410000011828850595673673096_",
    x: -1,
    y: -0.45,
    transform: "matrix(0.0328 -0.9995 0.9995 0.0328 -0.1209 41.0391)",
    width: 44.29,
    height: 42.06
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029731010328365093470000009418161865597166505_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147214374176044115410000011828850595673673096_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000029731010328365093470000009418161865597166505_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.5
    },
    x1: 41.68,
    y1: 0.53,
    x2: 0.6,
    y2: 40.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxausgewaehlt);
export default __webpack_public_path__ + "static/media/checkboxausgewaehlt.a6a907f13b737c6a4f15e149e1c68c98.svg";
export { ForwardRef as ReactComponent };